import { addTrailingNewLine } from "./addTrailingNewLine.js";
function addBlankLine(state, config) {
  if ((!state || state.endsWith("\n\n")) && !(config == null ? void 0 : config.force)) {
    return state;
  } else {
    return addTrailingNewLine(state) + "\n";
  }
}
export {
  addBlankLine
};
//# sourceMappingURL=addBlankLine.js.map
